import { createMemo, For } from "solid-js";
import type { GameController } from "../../app/controller";
import { describeLogEntryShort } from "../lib/describe";

export function MoveLog(props: { controller: GameController }) {
  const state = () => props.controller.store.state;
  // Newest first.
  const entries = createMemo(() => state().log.slice().reverse());

  return (
    <div class="log">
      <For each={entries()} fallback={<div class="entry">No moves yet.</div>}>
        {(entry) => {
          // The turn-limit entry is a neutral system event with no actor.
          if (!("player" in entry)) {
            return (
              <div class="entry system">
                <span>{describeLogEntryShort(entry, state())}</span>
              </div>
            );
          }
          return (
            <div class="entry" classList={{ p0: entry.player === 0, p1: entry.player === 1 }}>
              <span class="who">{state().players[entry.player].name}:</span>
              <span>{describeLogEntryShort(entry, state())}</span>
            </div>
          );
        }}
      </For>
    </div>
  );
}
